module.exports = __webpack_public_path__ + "static/media/office.921779b8.svg";